import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where, orderBy, updateDoc, doc, Timestamp, } from "firebase/firestore";
import { db } from "../firebase/config.js";
import { useAuth } from "../auth/useAuth.js";
/**
 * Migrated from `notifications` collection to `messages` collection.
 * Queries messages where the current user is in recipients.ids,
 * maps readBy to a boolean read state.
 */
export function useNotifications() {
    const { user } = useAuth();
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!user?.uid) {
            setNotifications([]);
            setUnreadCount(0);
            setLoading(false);
            return;
        }
        setLoading(true);
        const q = query(collection(db, "messages"), where("recipients.ids", "array-contains", user.uid), orderBy("createdAt", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((docSnap) => {
                const raw = docSnap.data();
                const readBy = raw.readBy || {};
                return {
                    id: docSnap.id,
                    userId: user.uid,
                    type: raw.type || "system",
                    title: raw.title || "",
                    body: raw.body || "",
                    data: raw.data || {},
                    read: !!readBy[user.uid],
                    createdAt: raw.createdAt?.toDate?.() ?? raw.createdAt ?? new Date(),
                };
            });
            setNotifications(data);
            setUnreadCount(data.filter((n) => !n.read).length);
            setLoading(false);
            setError(null);
        }, (err) => {
            console.error("useNotifications error:", err);
            setError(err.message);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [user?.uid]);
    const markAsRead = async (messageId) => {
        if (!user?.uid)
            return;
        await updateDoc(doc(db, "messages", messageId), {
            [`readBy.${user.uid}`]: { readAt: Timestamp.now() },
        });
    };
    const markAllAsRead = async () => {
        if (!user?.uid)
            return;
        const unread = notifications.filter((n) => !n.read);
        await Promise.all(unread.map((n) => updateDoc(doc(db, "messages", n.id), {
            [`readBy.${user.uid}`]: { readAt: Timestamp.now() },
        })));
    };
    return { notifications, unreadCount, loading, error, markAsRead, markAllAsRead };
}
//# sourceMappingURL=useNotifications.js.map